<template>
  <v-card
    :class="getCardClass()"
    :style="`width:${width ? width : null}; padding:15px !important`"
  >
    <v-list-item>
      <v-list-item-avatar
        tile
        :style="noGotoDetail ? '' : 'cursor: pointer'"
        @click="noGotoDetail ? null : gotoDetail(item.Id)"
        size="120"
        class="rounded-lg"
      >
        <v-img :src="mainImage"></v-img>
      </v-list-item-avatar>

      <v-list-item-content
        :style="noGotoDetail ? '' : 'cursor: pointer'"
        @click="noGotoDetail ? null : gotoDetail(item.Id)"
      >
        <v-list-item-title>
          <span
            style="font-size: 15px"
            class="font-weight-bold defaultColor--text mb-0"
          >
            {{ item.Title }}
          </span>
        </v-list-item-title>

        <v-list-item-subtitle class="mt-1 wrap-text">
          <span
            style="font-size: 13px"
            class="defaultColor--text mr-2"
            v-html="item.Content"
          ></span>
        </v-list-item-subtitle>

        <v-list-item-subtitle class="mt-1 wrap-text">
          

            <div class="cityStyle defaultColor--text mr-2">{{ getCity }}</div>

          <div class="priceStyle defaultColorLight--text">{{ getPrice }}</div>
          <div class="dateStyle">
            {{ moment(item.CreatedAt).locale("tr").fromNow() }}
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="buttonVisible">
        <v-btn
          color="defaultColor"
          class="white--text text-capitalize mr-2 elevation-0"
          rounded
          :icon="buttonType == 'icon' ? true : false"
          :disabled="buttonDisabled"
          @click="gotoDetail(item.Id)"
        >
          {{ buttonType == "icon" ? "" : this.buttonText }}
          <v-icon v-if="buttonType == 'icon'" size="20">{{
            this.buttonIconName
          }}</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-divider v-if="divider" />
  </v-card>
</template>

<script>
import DepartmantIcon from "../../components/General/DepartmantIcon.vue";

export default {
  data() {
    return {};
  },
  props: {
    item: Object,
    buttonText: String,
    buttonDisabled: Boolean,
    buttonVisible: {
      type: Boolean,
      default: false,
    },
    buttonIconName: {
      type: String,
      default: "mdi-cloud",
    },
    buttonType: {
      type: String,
      default: "button",
    },
    noGotoDetail: {
      type: Boolean,
      default: false,
    },
    company: String,
    noBg: Boolean,
    divider: Boolean,
    width: String,
  },
  components: {
    DepartmantIcon,
  },
  mounted() {},
  methods: {
    getCardClass() {
      if (this.noBg) {
        return "noBgCard";
      } else {
        return "mx-3 defaultCardClass mb-5";
      }
    },

    gotoDetail(id) {
      this.$router.push({ path: `/advertDetail/${id}` });
    },
  },
  computed: {
    mainImage() {
      if (this.item.Files.length > 0) {
        return this.item.Files[0].LocalUrl;
      } else {
        return null;
      }
    },
    getPrice() {
      if (this.item.Properties.length > 0) {
        let price = this.item.Properties.filter((x) => x.Key === "fiyat");
        if (price.length > 0) return price[0].Value + " TL";
        else return "";
      } else {
        return "";
      }
    },

    getCity() {
      if (this.item.Properties.length > 0) {
        let city = this.item.Properties.filter((x) => x.Key === "sehir");
        if (city.length > 0) return city[0].Value;
        else return "";
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
.noBgCard {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0px solid red !important;
  box-shadow: none !important;
}

.priceStyle {
  margin-top: 5px;
  font-weight: 600;
}

.cityStyle {
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 10px;
}

.dateStyle {
  margin-top: 5px;
  font-size: 12px;
}
</style>
